import Term from "../../term/Term";

export default class LearnedTermsResult {
  learnedTerms: Term[];

  constructor(learnedTerms: Term[]) {
    this.learnedTerms = learnedTerms;
  }
}
